// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__uT7Rl","filesListContainer":"PosDisputesFiles_filesListContainer__3bGua","filesButton":"PosDisputesFiles_filesButton__1_6xY"};